import { swSettings } from "app/common/services/swSettings";
import { EAvailabilityMode } from "app/common/services/pageClaims";

export const getIsSidebar3ClaimOpen = (): boolean =>
    swSettings.components?.Home?.resources?.["Sidebar3.0"] !== EAvailabilityMode.HIDDEN ||
    !swSettings.components?.Home?.resources?.["HasLicense"];
